import * as React from 'react';
import Skeleton from '@mui/material/Skeleton';
import Box from '@mui/material/Box';

export type PillsNavbarSkeletonProps = {
  count?: number;
};

export function PillsNavbarSkeleton({ count = 5 }: PillsNavbarSkeletonProps) {
  return (
    <Box
      sx={{
        display: 'flex',
        flexWrap: 'nowrap',
        overflow: 'hidden',
        gap: '40px',
        alignItems: 'flex-start',
      }}
    >
      {Array.from({ length: count }).map((_, index) => (
        <Box
          key={index}
          sx={{
            display: 'flex',
            gap: '16px',
            justifyContent: 'center',
            alignItems: 'center',
            padding: '14px',
            borderRadius: '8px',
          }}
        >
          <Box
            sx={{
              display: 'flex',
              gap: '16px',
              alignItems: 'center',
              alignSelf: 'stretch',
              my: 'auto',
            }}
          >
            <Skeleton
              variant="rectangular"
              width={38}
              height={38}
              sx={{
                borderRadius: '8px',
                flexShrink: 0,
                alignSelf: 'stretch',
              }}
            />
            <Box
              sx={{
                display: 'flex',
                flexDirection: 'column',
                justifyContent: 'center',
                alignSelf: 'stretch',
                width: '98px',
              }}
            >
              <Skeleton variant="text" width={98} height={12} sx={{ borderRadius: '30px' }} />
              <Skeleton
                variant="text"
                width={64}
                height={12}
                sx={{
                  borderRadius: '30px',
                  mt: 1,
                }}
              />
            </Box>
          </Box>
        </Box>
      ))}
    </Box>
  );
}
